import { render, staticRenderFns } from "./policylibrary.vue?vue&type=template&id=e2b5e094&"
import script from "./policylibrary.vue?vue&type=script&lang=js&"
export * from "./policylibrary.vue?vue&type=script&lang=js&"
import style0 from "./policylibrary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports